let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kiT3C")).then(() => parcelRequire('kaRTf'));